/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { GET_REALM_SETTINGS_START, GET_REALM_SETTINGS_SUCCESS, GET_REALM_SETTINGS_FAILURE, SET_REALM_INFO } from './types';
import { formDefaultValues } from '../../container/Settings/constants';

export const initialState = {
  realmSettings: formDefaultValues,
  realmInfo: { envType: "" },
  isLoading: true,
  error: undefined as any
};

export const realmSettingsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_REALM_SETTINGS_START:
      return {
        ...state,
        isLoading: true,
        error: undefined
      };
    case SET_REALM_INFO:
      return {
        ...state,
        realmInfo: action.realmInfo
      }
    case GET_REALM_SETTINGS_SUCCESS:
      return {
        ...state,
        realmSettings: action.realmSettings,
        isLoading: false,
        error: undefined
      };
    case GET_REALM_SETTINGS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    default:
      return state;
  }
};